module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Many thanks to all my invisible friends who shared their painful stories about what it’s like to live with an alcoholic parent, and to Carl Loerwald at the Washtenaw Alano Club in Ann Arbor, Michigan, for all his help.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Thanks also to:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Jennifer Klonsky, whose tough suggestions made "), _c('span', {
    staticClass: "strikethrough"
  }, [_vm._v("me cry")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Gone")]), _vm._v(" so much better. And, of course, to my agent, Michael Bourret, my favorite person on earth, for everything and more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Diane Blake Harper, for being wonderful and for having the tackiest snow-globe collection ever. To Marcia and Dan Levy for all the early help—it was an honor to learn things from you. And to Joanne Levy for the priceless feedback. Go, NDP!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Matt and Kilian, for being awesome guys; Rachel Heitkamp and Kennedy, for letting me use their cool buzzword; and to Trevor Bowler, because I promised.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("And to all the fans of the Wake trilogy: Thank you from the bottom of my heart for spreading the word about Janie and Cabe. You are amazing. I am grateful.")])]), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("To anyone whose life is impacted by someone else’s drinking problem, please check out Alateen or Al-Anon at "), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.al-anon.alateen.org",
      "target": "_blank"
    }
  }, [_vm._v("www.al-anon.alateen.org")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0